import { Spinner } from "flowbite-react";
import { useSelector } from "react-redux";

const LoadingSpinner = (props) => {
  const { component } = props;
  const loading = useSelector((s) => s.loading);
  if (loading.isLoading && component) {
    return;
  }
  if (component) {
    if (loading.componentsLoading[component]) {
      return (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100  bg-opacity-95 z-[999999]">
          <Spinner size="xl"></Spinner>
        </div>
      );
    } else {
      return;
    }
  }
  if (loading.isLoading === true) {
    return (
      <div className="absolute inset-0 flex items-center justify-center  bg-gray-100 bg-opacity-95 z-[999999]">
        <Spinner size="xl"></Spinner>
      </div>
    );
  }
};

export default LoadingSpinner;
